// Interface for calc events
import _ from "lodash"

export interface CalcPayload {
  calcType: string,
  email: string,
  folderOrPropertyCalc: string,
  propertyIds: number[],
  userId: string,
  folderId: number
}

export enum CalcStatus {
  NOT_CALC = "",
  CALC_WITH_ERR = "Calculated w/Errors",
  IN_PROCESS = "Pending",
  CALCULATED = "Calculated",
  WARNING = "warningReviewInputs",
}

export function getCalcStatus(calcDetail) {
  const calcStatus = _.get(calcDetail, "status")
  const errordetail = _.get(calcDetail, "errors")

  if(!calcStatus && !errordetail) {
    return CalcStatus.NOT_CALC
  } else if(calcStatus === CalcStatus.CALC_WITH_ERR || (errordetail !== null && (calcStatus !== CalcStatus.IN_PROCESS && calcStatus !== null))) {
    return CalcStatus.CALC_WITH_ERR
  } else if(errordetail !== null && calcStatus === null) {
    return CalcStatus.WARNING
  } else if(calcStatus === CalcStatus.CALCULATED) {
    return CalcStatus.CALCULATED
  } else if(calcStatus === CalcStatus.IN_PROCESS) {
    return CalcStatus.IN_PROCESS
  }
}
